import { RedocStandalone } from "redoc";
import { useThemeContext } from "@freightsimple/ui-core/Theme/useThemeContext";
import { apiAccessRedocOptions } from "./Helpers/apiAccessRedocOptions";
import { ApiAccessFullViewportPane } from "./CustomComponents/Internal/ApiAccessFullViewportPane";
import "./Helpers/Redoc.css";

export function ApiDocumentationScreen() {
  const { resolvedTheme } = useThemeContext();
  const isDark = resolvedTheme === "dark";
  return (
    <ApiAccessFullViewportPane>
      {/* Redoc reads its theme once per mount, so remount it when the theme
          flips — it has no API for updating the palette in place. */}
      <RedocStandalone
        key={resolvedTheme}
        specUrl="/api-spec/freightsimple-openapi-spec-v1.yaml"
        options={apiAccessRedocOptions(isDark)}
      />
    </ApiAccessFullViewportPane>
  );
}
